import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { Panel } from "primereact/panel";
import { Fragment, useEffect} from "react";
import { insertLogs } from "../../homepurchase.service";
import PurchasePrice from "../Tab2/components/PurchasePrice";
import { useMediaQuery } from "react-responsive";
import { NumericFormat } from "react-number-format";

const amortizationYears = [
    { name: "15 Years", code: 15 },
    { name: "30 Years", code: 30 },
    { name: "40 Years", code: 40 }
]; 


const secondAmortizationYears = [
    { name: "12 Years", code: 12 },
]; 

const minValue = 0;
const maxValue = 100;

const Tab4 = ({ handleSettingsInputChange,handleSettingsInputChanges, handleSettingsSave, settings, handleLeftCalculations }) => {
    const isDesktopOrLaptop = useMediaQuery({
        query: '(min-width: 1224px)'
      })
    const isTablet = useMediaQuery({
        query: '(min-width: 768px) and (max-width: 1024px)'
      });

    useEffect(() => {
        const payload = {
            description: "View Settings",
        };
        insertLogs(payload);
    }, []);

    

    const renderFooter = () => {
        return (
            <div>
                <div className="grid">
                    <div className="lg:col-4 md:col-5"></div>
                    <div className="col-6 align-text-left">
                        <Button
                            label="Save"
                            className="p-button-raised p-button-warning p-button-lg"
                            onClick={() => handleSettingsSave()}
                        />
                    </div>
                </div>
            </div>
        );
    };

    return (
        <Fragment>
          
            <Panel
                header={`${isDesktopOrLaptop ? "" : "Settings"}`}
                className={`mb-2 ${isDesktopOrLaptop ? "OwnHouse" : "Settings"}`}
            >
                <div className={`mb-2 ${isDesktopOrLaptop ? "align-text" : ""} ${isTablet ? "w-90" : ""}`}>
                    <div className="grid">
                        <div className="col-12 md:col-12 lg:col-4">
                            <label className="mt-3">
                                First Loan Amortization
                            </label>
                        </div>
                        <div className="col-12 md:col-12 lg:col-5">
                            <div className="field">
                                <Dropdown
                                    className="vw-dropdown vw-dropdown-with-border"
                                    value={settings?.amortizationYears}
                                    options={amortizationYears}
                                    required={true}
                                    name="amortizationYears"
                                    onChange={handleSettingsInputChange}
                                    optionLabel="name"
                                    optionValue="code"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="grid">
                        <div className="col-12 md:col-12 lg:col-4">
                            <label className="mt-3">
                                Second Loan Amortization
                            </label>
                        </div>
                        <div className="col-12 md:col-12 lg:col-5">
                            <div className="field">
                                <Dropdown
                                    className="vw-dropdown vw-dropdown-with-border"
                                    value={settings?.secondAmortizationYears}
                                    options={secondAmortizationYears}
                                    required={true}
                                    name="secondAmortizationYears"
                                    onChange={handleSettingsInputChange}
                                    optionLabel="name"
                                    optionValue="code"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="grid">
                        <div className="col-12 md:col-12 lg:col-4">
                            <label className="">
                                Max Mortgage amount for Tax Deduction on First
                            </label>
                        </div>
                        <div className="col-12 md:col-12 lg:col-5">
                            <div className="field">
                                <div className="p-inputgroup">
                                    <NumericFormat
                                        className="input-field"
                                        style={{"width":"99%"}}
                                        thousandSeparator=","
                                        decimalScale={0}
                                        autoComplete="off"
                                        required={true}
                                        name="taxDeductionOnFirst"
                                        prefix="$ "
                                        disabled={false}
                                        onBlur={(values) => {
                                            handleSettingsInputChanges("taxDeductionOnFirst", values)
                                        }}
                                        value={settings?.taxDeductionOnFirst}
                                        // value={leftContentsettings?.purchasePrice ? FormatAmount(leftContentsettings?.purchasePrice) : 0}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="grid">
                        <div className="col-12 md:col-12 lg:col-4">
                            <label className="">
                                Max Mortgage amount for Tax Deduction on Second
                            </label>
                        </div>
                        <div className="col-12 md:col-12 lg:col-5">
                            <div className="field">
                                <div className="p-inputgroup">
                                    <NumericFormat
                                        className="input-field"
                                        style={{"width":"99%"}}
                                        thousandSeparator=","
                                        decimalScale={0}
                                        autoComplete="off"
                                        required={true}
                                        name="taxDeductionOnSecond"
                                        prefix="$ "
                                        disabled={false}
                                        onBlur={(values) => {
                                            handleSettingsInputChanges("taxDeductionOnSecond", values)
                                        }}
                                        value={settings?.taxDeductionOnSecond}
                                        // value={leftContentsettings?.purchasePrice ? FormatAmount(leftContentsettings?.purchasePrice) : 0}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="grid">
                        <div className="col-12 md:col-12 lg:col-4">
                            <label className="mt-3">Property Taxes</label>
                        </div>
                        <div className="col-12 md:col-12 lg:col-5">
                            <div className="field">
                                <div className="p-inputgroup">
                                    <NumericFormat
                                        className="input-field"
                                        style={{"width":"99%"}}
                                        thousandSeparator=","
                                        decimalScale={2}
                                        autoComplete="off"
                                        required={true}
                                        name="propertyTax"
                                        suffix=" %"
                                        isAllowed={(values) => {
                                            const { floatValue } = values;
                                            return floatValue === undefined || (floatValue >= minValue && floatValue <= maxValue);
                                          }}
                                        disabled={false}
                                        onBlur={(values) => {
                                            handleSettingsInputChanges("propertyTax", values)
                                        }}
                                        value={settings?.propertyTax}
                                        // value={leftContentsettings?.purchasePrice ? FormatAmount(leftContentsettings?.purchasePrice) : 0}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="grid">
                        <div className="col-12 md:col-12 lg:col-4">
                            <label className="mt-2">
                                Cap on Itemization of Property Taxes
                            </label>
                        </div>
                        <div className="col-12 md:col-12 lg:col-5">
                            <div className="field">
                                <div className="p-inputgroup">
                                    <NumericFormat
                                        className="input-field"
                                        style={{"width":"99%"}}
                                        thousandSeparator=","
                                        decimalScale={0}
                                        autoComplete="off"
                                        required={true}
                                        prefix="$ "
                                        name="capItemizationPropertyTax"
                                        disabled={false}
                                        onBlur={(values) => {
                                            handleSettingsInputChanges("capItemizationPropertyTax", values)
                                        }}
                                        value={
                                            settings?.capItemizationPropertyTax
                                        }
                                        
                                        // value={leftContentsettings?.purchasePrice ? FormatAmount(leftContentsettings?.purchasePrice) : 0}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="grid">
                        <div className="col-12 md:col-12 lg:col-4">
                            <label className="mt-3">Standard Deduction</label>
                        </div>
                        <div className="col-12 md:col-12 lg:col-5">
                            <div className="field">
                                <div className="p-inputgroup">
                                    <NumericFormat
                                        className="input-field"
                                        style={{"width":"99%"}}
                                        thousandSeparator=","
                                        autoComplete="off"
                                        required={true}
                                        name="standardDeduction"
                                        disabled={false}
                                        prefix="$ "
                                        decimalScale={0}
                                        value={settings?.standardDeduction}
                                        onBlur={(values) => {
                                            handleSettingsInputChanges("standardDeduction", values)
                                        }}
                                        // value={leftContentsettings?.purchasePrice ? FormatAmount(leftContentsettings?.purchasePrice) : 0}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="grid">
                        <div className="col-12 md:col-12 lg:col-4">
                            <label className="mt-3">Federal Tax Rate</label>
                        </div>
                        <div className="col-12 md:col-12 lg:col-5">
                            <div className="field">
                                <div className="p-inputgroup">
                                    {/* <InputText
                                        className="vw-input-nfl-border"
                                        autoComplete="off"
                                        required={true}
                                        name="federalTaxRate"
                                        disabled={false}
                                        value={settings?.federalTaxRate}
                                        onChange={handleSettingsInputChange}
                                        maxLength={2}
                                        // value={leftContentsettings?.purchasePrice ? FormatAmount(leftContentsettings?.purchasePrice) : 0}
                                    /> */}
                                     <NumericFormat
                                        className="input-field"
                                        style={{"width":"99%"}}
                                        thousandSeparator=","
                                        autoComplete="off"
                                        required={true}
                                        name="federalTaxRate"
                                        decimalScale={2}
                                        allowNegative={false}
                                        suffix=" %"
                                        isAllowed={(values) => {
                                            const { floatValue } = values;
                                            return floatValue === undefined || (floatValue <= maxValue);
                                          }}
                                        disabled={false}
                                        onBlur={(values) => {
                                            handleSettingsInputChanges("federalTaxRate", values)
                                        }}
                                        value={settings?.federalTaxRate}
                                        // value={leftContentsettings?.purchasePrice ? FormatAmount(leftContentsettings?.purchasePrice) : 0}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="grid">
                        <div className="col-12 md:col-12 lg:col-4">
                            <label className="mt-3">State Tax Rate</label>
                        </div>
                        <div className="col-12 md:col-12 lg:col-5">
                            <div className="field">
                                <div className="p-inputgroup">
                                    <NumericFormat
                                        className="input-field"
                                        style={{"width":"99%"}}
                                        thousandSeparator=","
                                        autoComplete="off"
                                        required={true}
                                        name="stateTaxRate"
                                        decimalScale={2}
                                        allowNegative={false}
                                        suffix=" %"
                                        isAllowed={(values) => {
                                            const { floatValue } = values;
                                            return floatValue === undefined || (floatValue <= maxValue);
                                          }}
                                        disabled={false}
                                        onBlur={(values) => {
                                            handleSettingsInputChanges("stateTaxRate", values)
                                        }}
                                        value={settings?.stateTaxRate}
                                        // value={leftContentsettings?.purchasePrice ? FormatAmount(leftContentsettings?.purchasePrice) : 0}
                                    />
                                    {/* <InputText
                                        className="vw-input-nfl-border"
                                        autoComplete="off"
                                        required={true}
                                        name="stateTaxRate"
                                        disabled={false}
                                        value={settings?.stateTaxRate}
                                        onChange={handleSettingsInputChange}
                                        maxLength={2} 
                                        // value={leftContentsettings?.purchasePrice ? FormatAmount(leftContentsettings?.purchasePrice) : 0}
                                    /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="grid">
                        <div className="col-12 md:col-12 lg:col-4">
                            <label className="mt-3">Rental Increase</label>
                        </div>
                        <div className="col-12 md:col-12 lg:col-5">
                            <div className="field">
                                <div className="p-inputgroup">
                                    <NumericFormat
                                        className="input-field"
                                        style={{"width":"99%"}}
                                        thousandSeparator=","
                                        autoComplete="off"
                                        required={true}
                                        name="rentalIncrease"
                                        decimalScale={2}
                                        allowNegative={false}
                                        suffix=" %"
                                        disabled={false}
                                        isAllowed={(values) => {
                                            const { floatValue } = values;
                                            return floatValue === undefined || (floatValue <= maxValue);
                                          }}
                                          onBlur={(values) => {
                                            handleSettingsInputChanges("rentalIncrease", values)
                                        }}
                                        value={settings?.rentalIncrease ? settings?.rentalIncrease : 10}
                                        // value={leftContentsettings?.purchasePrice ? FormatAmount(leftContentsettings?.purchasePrice) : 0}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="grid">
                        <div className="col-12 md:col-12 lg:col-4">
                            <label className="mt-3">Average Appreciation</label>
                        </div>
                        <div className="col-12 md:col-12 lg:col-5">
                            <div className="field">
                                <div className="p-inputgroup">
                                    <NumericFormat
                                        className="input-field"
                                        style={{"width":"99%"}}
                                        thousandSeparator=","
                                        autoComplete="off"
                                        required={true}
                                        name="averageAppreciation"
                                        decimalScale={2}
                                        allowNegative={false}
                                        suffix=" %"
                                        disabled={false}
                                        isAllowed={(values) => {
                                            const { floatValue } = values;
                                            return floatValue === undefined || (floatValue <= maxValue);
                                          }}
                                          onBlur={(values) => {
                                            handleSettingsInputChanges("averageAppreciation", values)
                                        }}
                                        value={settings?.averageAppreciation ? settings?.averageAppreciation : 7}
                                        // value={leftContentsettings?.purchasePrice ? FormatAmount(leftContentsettings?.purchasePrice) : 0}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="grid">
                        <div className="col-12 md:col-12 lg:col-4">
                            <label className="mt-3">Increase in Property Taxes</label>
                        </div>
                        <div className="col-12 md:col-12 lg:col-5">
                            <div className="field">
                                <div className="p-inputgroup">
                                    <NumericFormat
                                        className="input-field"
                                        style={{"width":"99%"}}
                                        thousandSeparator=","
                                        autoComplete="off"
                                        required={true}
                                        name="increasePropertyTax"
                                        decimalScale={2}
                                        allowNegative={false}
                                        suffix=" %"
                                        disabled={false}
                                        isAllowed={(values) => {
                                            const { floatValue } = values;
                                            return floatValue === undefined || (floatValue <= maxValue);
                                          }}
                                          onBlur={(values) => {
                                            handleSettingsInputChanges("increasePropertyTax", values)
                                        }}
                                        value={settings?.increasePropertyTax ? settings?.increasePropertyTax : 2}
                                        // value={leftContentsettings?.purchasePrice ? FormatAmount(leftContentsettings?.purchasePrice) : 0}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="grid">
                        <div className="col-12 md:col-12 lg:col-4">
                            <label className="mt-3">Inflation Rate</label>
                        </div>
                        <div className="col-12 md:col-12 lg:col-5">
                            <div className="field">
                                <div className="p-inputgroup">
                                    <NumericFormat
                                        className="input-field"
                                        style={{"width":"99%"}}
                                        thousandSeparator=","
                                        autoComplete="off"
                                        required={true}
                                        name="inflationRate"
                                        suffix=" %"
                                        decimalScale={2}
                                        allowNegative={false}
                                        disabled={false}
                                        isAllowed={(values) => {
                                            const { floatValue } = values;
                                            return floatValue === undefined || (floatValue <= maxValue);
                                          }}
                                          onBlur={(values) => {
                                            handleSettingsInputChanges("inflationRate", values)
                                        }}
                                        value={settings?.inflationRate ? settings?.inflationRate : 3}
                                        // value={leftContentsettings?.purchasePrice ? FormatAmount(leftContentsettings?.purchasePrice) : 0}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="grid">
                        <div className="col-12 md:col-12 lg:col-4">
                            <label className="mt-3">Add Interest on Equity </label>
                        </div>
                        <div className="col-12 md:col-12 lg:col-5">
                            <div className="field">
                                <div className="p-inputgroup">
                                    <NumericFormat
                                        className="input-field"
                                        style={{"width":"99%"}}
                                        thousandSeparator=","
                                        autoComplete="off"
                                        required={true}
                                        name="interestOnEquity"
                                        suffix=" %"
                                        decimalScale={2}
                                        allowNegative={false}
                                        disabled={false}
                                        isAllowed={(values) => {
                                            const { floatValue } = values;
                                            return floatValue === undefined || (floatValue <= maxValue);
                                          }}
                                          onBlur={(values) => {
                                            handleSettingsInputChanges("interestOnEquity", values)
                                        }}
                                        value={settings?.interestOnEquity ? settings?.interestOnEquity : 0}
                                        // value={leftContentsettings?.purchasePrice ? FormatAmount(leftContentsettings?.purchasePrice) : 0}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {renderFooter()}
                </div>
            </Panel>
        </Fragment>
    );
};

export default Tab4;